import { render, staticRenderFns } from "./airport-select.vue?vue&type=template&id=a61af26a&"
import script from "./airport-select.vue?vue&type=script&lang=js&"
export * from "./airport-select.vue?vue&type=script&lang=js&"
import style0 from "./airport-select.vue?vue&type=style&index=0&id=a61af26a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzSelect: require('/opt/airport.kg/node_modules/razlet-ui/src/components/select/index.vue').default})
